module.exports = __webpack_public_path__ + "02_mustache_grey.3135c78e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer3/02_mustache_grey.png
// module id = nemH
// module chunks = 0